import { render, staticRenderFns } from "./token-exchange.vue?vue&type=template&id=5cf6ded7&scoped=true"
import script from "./token-exchange.vue?vue&type=script&lang=ts"
export * from "./token-exchange.vue?vue&type=script&lang=ts"
import style0 from "./token-exchange.vue?vue&type=style&index=0&id=5cf6ded7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6ded7",
  null
  
)

export default component.exports